import { Language } from '@coolblue-development/constants';
export default class VariationsRepository {
    static getVariationsMap() {
        var _a;
        return (_a = global.variationsMap) !== null && _a !== void 0 ? _a : VariationsRepository.getEmptyVariationsMap();
    }
    static storeVariationsMap(value) {
        global.variationsMap = value;
    }
    static getEmptyVariationsMap() {
        return {
            [Language.DUTCH]: {},
            [Language.ENGLISH]: {},
            [Language.FRENCH]: {},
            [Language.GERMAN]: {},
        };
    }
}
//# sourceMappingURL=VariationsRepository.js.map